import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';

function ReactMuiTableColumnHeaderTextEllipsis({ column }) {
  return (
    <Box
      whiteSpace="noWrap"
      overflow="hidden"
      style={{ cursor: 'pointer' }}
      marginRight={1}
      display="flex"
      flexDirection="row"
    >
      <Box component="div" title={column.heading}>
        {column.heading}
      </Box>
    </Box>
  );
}
ReactMuiTableColumnHeaderTextEllipsis.propTypes = {
  column: PropTypes.arrayOf.isRequired,
};
export default ReactMuiTableColumnHeaderTextEllipsis;
